<template>
<card>

    <b-form @submit.prevent="updatePengguna">
        <h6 class="heading-small text-muted mb-4">Profil Pengguna</h6>

        <div class="pl-lg-4">
            <b-row>
                <b-col lg="3">
                    No Kad Pengenalan:
                </b-col>
                <b-col>
                    {{clonePengguna.NoKP}}
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="3">
                    &nbsp;
                </b-col>
            </b-row> -->
            <b-row>
                <b-col lg="3">
                    Nama:
                </b-col>
                <b-col>
                    {{clonePengguna.Nama}}
                </b-col>
            </b-row>
            <b-row>
                <!-- <b-col lg="3">
                    &nbsp;
                </b-col> -->
            </b-row>
            <b-row>
                <b-col lg="3">
                    Jawatan:
                </b-col>
                <b-col>
                    {{clonePengguna.jawatan}}
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3">
                    No Telefon Pejabat:
                </b-col>
                <b-col>
                    {{clonePengguna.NoTelPej}}
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3">
                    Emel:
                </b-col>
                <b-col>
                    {{clonePengguna.Emel}}
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3">
                    Bahagian:
                </b-col>
                <b-col>
                    {{clonePengguna.bahagian}}
                </b-col>
            </b-row>
        </div>
        <hr class="my-4">

        <!-- Address -->
        <h6 class="heading-small text-muted mb-4">Tetapan Pengguna</h6>

        <div class="pl-lg-4">
            <b-row>
                <b-col md="6">
                    <base-input label="Peranan">
                        <select class="form-control" v-model="clonePengguna.roleID">
                            <option value="1">Pengguna Asas</option>
                            <option value="2">Pegawai BGE, JPA</option>
                            <option value="3">Pentadbir Sistem</option>
                            <option value="4">Pegawai PSM Kementerian/Agensi</option>
                        </select>
                    </base-input>
                </b-col>
            </b-row>

            <b-form-row>
                <b-col>
                    <b-form-group label="Status">
                        <b-form-checkbox v-model="clonePengguna.StatusAktif" name="status" value="1" unchecked-value="0" switch>
                            {{ checked }}
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-form-row>
        </div>
        <hr class="my-4">

        <!-- Button -->
        <div class="pl-lg-4">
            <b-row>
                <b-col md="12" class="text-md-right">
                    <b-button variant="success" type="submit">SIMPAN</b-button>
                    <b-button variant="danger" @click="batal()">BATAL</b-button>
                </b-col>
            </b-row>
        </div>

    </b-form>
</card>
</template>

<script>
import swal from "sweetalert2";
import PenggunaService from "@/services/PenggunaService.js";
export default {
    name: 'KemaskiniPengguna',
    props: {
        pengguna: {
            type: Object
        },
    },

    methods: {
        updatePengguna() {
            console.log("editpengguna: ", this.clonePengguna);

            PenggunaService.setUpdatePengguna(this.clonePengguna)
                .then((resp) => {
                    // console.log(resp.data)
                    swal.fire({
                        title: `Kemaskini Berjaya`,
                        text: "",
                        buttonsStyling: true,
                        icon: "success",
                    });

                    this.$emit("refreshPaging");
                    this.batal();
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        batal() {
            this.$emit("batal");
        },
    },

    computed: {
        clonePengguna() {
            return _.cloneDeep(this.pengguna)
        },
        checked() {
            if (this.pengguna.StatusAktif == 1) {
                return 'Aktif'
            } else {
                return 'Tidak Aktif'
            }
        }
    },
}
</script>
